type AgendaEmailAddressProps = {
    name: string;
    address: string;
};

export default class AgendaEmailAddress {
    name: string;

    address: string;

    constructor({ name, address }: AgendaEmailAddressProps) {
        this.name = name;
        this.address = address;
    }
}
